import { render, staticRenderFns } from "./coverage_list.vue?vue&type=template&id=26667f30&scoped=true&"
import script from "./coverage_list.vue?vue&type=script&lang=js&"
export * from "./coverage_list.vue?vue&type=script&lang=js&"
import style0 from "./coverage_list.vue?vue&type=style&index=0&id=26667f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26667f30",
  null
  
)

export default component.exports